import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({ providedIn: 'root' })
export class SidenavService {
  private sidenav!: MatSidenav;

  // BehaviorSubject to hold the state of the sidenav
  private sidenavStateSubject = new BehaviorSubject<boolean>(false);
  sidenavState$: Observable<boolean> = this.sidenavStateSubject.asObservable();

  // Assign the MatSidenav instance to the service
  setSidenav(sidenav: MatSidenav): void {
    this.sidenav = sidenav;

    // Initialize the BehaviorSubject with the current state
    this.sidenavStateSubject.next(this.sidenav.opened);
  }

  // Open the sidenav and update the state
  async open(): Promise<void> {
    await this.sidenav.open();
    this.sidenavStateSubject.next(true); // Emit new state after opening
  }

  // Close the sidenav and update the state
  async close(): Promise<void> {
    await this.sidenav.close();
    this.sidenavStateSubject.next(false); // Emit new state after closing
  }

  // Toggle the sidenav and update the state
  async toggle(): Promise<void> {
    await this.sidenav.toggle();
    this.sidenavStateSubject.next(this.sidenav.opened); // Emit new state after toggling
  }

  // Return the observable of the sidenav state
  getSidenavState(): Observable<boolean> {
    return this.sidenavState$;
  }
}
